/* eslint-disable no-console */

const logger = {
  error(error) {
    const isServerError = error.response;

    if (!isServerError) {
      console.error(error);
    }
  },

  info(...args) {
    if (!window._debugMode) {
      return;
    }

    console.log(...args);
  },

  log(...args) {
    console.log(...args);
  },

  warn(description, extraDetails) {
    console.warn(description);

    if (extraDetails) {
      console.log(extraDetails);
    }
  }
};



export default logger;
